module.exports = __webpack_public_path__ + "img/1_gucci.cd9683e0.jpg";